module.exports = __webpack_public_path__ + "img/vehicle-options-white-honda.4bfd3417.png";